import React, { useEffect, useState } from "react";
import Spinner from "../../Components/Loading/Spinner";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  CreateEventByAdminFeatured,
  DeleteFeaturedEvent,
  GetAllFeaturedEvents,
} from "../../redux/actions/Admin/AdminActions";
import { SearchEvents, GetUserCreatedEvents } from "../../redux/actions/Events";
import { ApiMediaURL } from "../../setting/GlobleVariable";
import { Loading } from "notiflix";
import { Plus, RefreshCw, Search, Star, Trash2, X } from "lucide-react";

const thClass =
  "text-left px-5 py-3.5 text-[10px] text-[#E52324] uppercase tracking-widest whitespace-nowrap";
const inputClass =
  "w-full px-4 py-3 rounded-xl bg-white/[0.04] border border-white/[0.08] text-white text-[14px] placeholder:text-white/25 focus:outline-none focus:ring-2 focus:ring-[#E52324]/30 focus:border-[#E52324]/40 transition-all";
const labelClass =
  "block text-[10px] text-white/40 uppercase tracking-wider mb-1.5";

function FeatureEvents() {
  const [createevent, setcreateevent] = useState(false);
  const [search, setSearch] = useState("");
  const [showDropdown, setDropDown] = useState(null);
  const [Paragraph, setParagraph] = useState("");
  const [image, setImage] = useState(null);
  const [event, setEvent] = useState({});
  const [combinedSearchResults, setCombinedSearchResults] = useState([]);
  const serachevents = useSelector((state) => state.events.serachevents);
  const isLoading = useSelector((state) => state.events.isLoading);
  const userCreatedEvents = useSelector((state) => state.events.userCreatedEvents);
  const FeaturedEventsdata = useSelector(
    (state) => state.Admin.featuredEvents
  )?.filter((item) => item.isFeatured === true);

  const dispatch = useDispatch();

  const uploadImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(file);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleSelectChange = (e) => {
    const filterEvent = combinedSearchResults?.filter(
      (item) => (item.id || item._id) == e.target.value
    );
    setEvent(filterEvent && filterEvent[0]);
  };

  const createeventFunction = async () => {
    if (!Paragraph || !event || !image) {
      return toast.error("Please Enter All fields");
    }
    const formdata = new FormData();
    const url = "create/feature";
    formdata.append("event", JSON.stringify(event));
    formdata.append("paragarph", Paragraph);
    formdata.append("file", image);
    formdata.append("isFeatured", true);

    await dispatch(CreateEventByAdminFeatured(formdata, url));
    setcreateevent(false);
    setEvent({});
    setParagraph("");
    setImage(null);
    setSearch("");
    setDropDown(null);
  };

  const UserLocationdata = {};

  useEffect(() => {
    dispatch(GetAllFeaturedEvents());
    dispatch(GetUserCreatedEvents());
  }, [dispatch]);

  // Combine TEVO search results with user-created events that match the search term
  useEffect(() => {
    if (search.trim() && showDropdown) {
      const term = search.toLowerCase().trim();

      // Filter user-created events by search term
      const matchingUserEvents = (userCreatedEvents || []).filter((userEvent) => {
        const eventName = (userEvent.name || '').toLowerCase();
        const venueName = (userEvent.venue?.name || '').toLowerCase();
        const performerNames = userEvent.performances?.map(p => (p.performer?.name || '').toLowerCase()).join(' ') || '';

        return eventName.includes(term) ||
               venueName.includes(term) ||
               performerNames.includes(term);
      });

      // Combine TEVO events (from API) with filtered user-created events
      const combined = [
        ...(serachevents || []),
        ...matchingUserEvents
      ];

      // Remove duplicates based on event ID (prefer TEVO events if there's a match)
      const uniqueEvents = combined.filter((event, index, self) =>
        index === self.findIndex(e => e.id === event.id || e._id === event._id)
      );

      setCombinedSearchResults(uniqueEvents);
    } else {
      setCombinedSearchResults([]);
    }
  }, [search, serachevents, userCreatedEvents, showDropdown]);

  const adminloading = useSelector((state) => state.Admin.adminloading);
  useEffect(() => {
    if (adminloading === true) {
      Loading.standard("Loading Please Wait");
    } else {
      Loading.remove();
    }
  }, [adminloading]);

  const resetForm = () => {
    setcreateevent(false);
    setEvent({});
    setParagraph("");
    setImage(null);
    setSearch("");
    setDropDown(null);
  };

  return (
    <div className="p-6 sm:p-8">
      <div className="w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 my-2">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#E52324]/15 border border-[#E52324]/20 flex items-center justify-center shrink-0">
            <Star className="w-5 h-5 text-[#E52324]" strokeWidth={2} />
          </div>
          <div>
            <h1 className="text-[22px] text-white" style={{ fontWeight: 800 }}>
              Latest Events
            </h1>
            <p className="text-white/30 text-[12px] mt-1">
              Manage featured latest events. ({FeaturedEventsdata?.length || 0} total)
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            type="button"
            onClick={() => dispatch(GetAllFeaturedEvents())}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border border-white/[0.08] text-white/50 hover:text-white hover:bg-white/[0.03] text-[12px] transition-all"
            style={{ fontWeight: 600 }}
          >
            <RefreshCw className="w-4 h-4" />
            Reload
          </button>
          <button
            type="button"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[12px] transition-all shadow-lg shadow-[#E52324]/20"
            style={{ fontWeight: 600 }}
            onClick={() => setcreateevent(true)}
          >
            <Plus className="w-4 h-4" />
            Add New
          </button>
        </div>
      </div>
      {/* ============================= table  */}
      <div className="my-4">
        <div className="relative overflow-x-auto bg-[#0B1120] border border-[#1a1f30] rounded-2xl">
          <table className="w-full text-sm text-left rtl:text-right text-color2">
            <thead className="bg-[#0B1120] border-b border-[#1a1f30]">
              <tr>
                <th scope="col" className={thClass}>
                  ID
                </th>
                <th scope="col" className={thClass}>
                  Image
                </th>
                <th scope="col" className={thClass}>
                  Event Name
                </th>
                <th scope="col" className={thClass}>
                  Desicription
                </th>
                <th scope="col" className={thClass}>
                  isFeatured
                </th>
                <th scope="col" className={thClass}>
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              {FeaturedEventsdata &&
                FeaturedEventsdata?.map((item, index) => {
                  return (
                    <tr
                      key={item?._id || index}
                      className="border-b border-[#1a1f30]/30 last:border-b-0 hover:bg-white/[0.015] transition-colors"
                    >
                      <td className="px-5 py-3.5 text-[12px] text-blue-400 whitespace-nowrap" style={{ fontWeight: 600 }}>
                        #{item && item?._id?.slice(0, 4)}
                      </td>
                      <td className="px-5 py-3.5">
                        {item?.image ? (
                          <img
                            src={`${ApiMediaURL}/${item.image}`}
                            alt=""
                            className="w-10 h-10 rounded-lg border border-[#1a2744] object-cover"
                          />
                        ) : (
                          <span className="text-xs text-white/25">—</span>
                        )}
                      </td>
                      <td className="px-5 py-3.5 text-[12px] text-white/80 max-w-[220px] truncate" style={{ fontWeight: 600 }}>
                        {item?.event &&
                        item?.event[0]?.name &&
                        item?.event[0]?.name?.length > 30
                          ? `${item?.event[0]?.name?.slice(0, 30)}...`
                          : item?.event[0]?.name}
                      </td>
                      <td className="px-5 py-3.5 text-[12px] text-white/40 max-w-[220px] truncate">
                        {item && item?.paragarph && item?.paragarph?.length > 30
                          ? `${item?.paragarph?.slice(0, 30)}...`
                          : item?.paragarph}
                      </td>
                      <td className="px-5 py-3.5">
                        {item && item?.isFeatured === true ? (
                          <span className="inline-flex px-2 py-0.5 rounded-full text-[9px] uppercase tracking-wider bg-emerald-500/15 text-emerald-400" style={{ fontWeight: 600 }}>
                            True
                          </span>
                        ) : (
                          <span className="inline-flex px-2 py-0.5 rounded-full text-[9px] uppercase tracking-wider bg-red-500/15 text-red-400" style={{ fontWeight: 600 }}>
                            false
                          </span>
                        )}
                      </td>
                      <td className="px-5 py-3.5">
                        <button
                          type="button"
                          className="w-9 h-9 rounded-lg flex items-center justify-center bg-red-500/10 text-red-400 hover:bg-red-500/20 transition-all"
                          onClick={() => {
                            dispatch(DeleteFeaturedEvent(item?._id));
                          }}
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= modal  */}
      {createevent && (
        <div className="fixed inset-0 z-[99] flex items-center justify-center p-4 bg-black/60">
          <div className="relative w-full max-w-xl max-h-[90vh] overflow-y-auto rounded-2xl bg-[#0B1120] border border-[#1a2744] shadow-xl">
            <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 border-b border-[#1a2744] bg-[#0B1120]">
              <h3 className="text-[16px] text-white" style={{ fontWeight: 700 }}>
                New Latest Event
              </h3>
              <button
                type="button"
                onClick={resetForm}
                className="p-1.5 rounded-lg text-white/40 hover:text-white hover:bg-white/[0.05] transition-all"
                aria-label="Close"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="px-5 py-5 space-y-5">
              <div className="w-[100%]">
                <label htmlFor="latest-search" className={labelClass}>
                  Search Event By Name
                </label>
                <div className="flex justify-start place-items-center gap-2">
                  <input
                    id="latest-search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setDropDown(true);
                        dispatch(SearchEvents(search, UserLocationdata));
                      }
                    }}
                    type="text"
                    placeholder="Please Enter Event Name"
                    className={inputClass}
                  />
                  <button
                    type="button"
                    className="inline-flex items-center gap-2 px-4 py-3 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[12px] shrink-0 transition-colors"
                    style={{ fontWeight: 600 }}
                    onClick={() => {
                      if (search) {
                        setDropDown(true);
                        dispatch(SearchEvents(search, UserLocationdata));
                      }
                    }}
                  >
                    <Search className="w-4 h-4" />
                    Search
                  </button>
                </div>
              </div>

              {showDropdown && (
                <div className="w-full mt-2">
                  <label htmlFor="latest-event" className={labelClass}>
                    Select Event
                  </label>
                  <select
                    id="latest-event"
                    className={`${inputClass} cursor-pointer`}
                    onChange={(e) => handleSelectChange(e)}
                  >
                    <option value="" className="bg-[#0B1120]">
                      Please select an event
                    </option>
                    {isLoading ? (
                      <option value={""} disabled className="bg-[#0B1120]">
                        Loading...
                      </option>
                    ) : (
                      <>
                        {combinedSearchResults?.map((item, index) => {
                          return (
                            <option value={item?.id || item?._id} key={index} className="bg-[#0B1120]">
                              {item?.name}
                            </option>
                          );
                        })}
                      </>
                    )}
                  </select>
                  {isLoading && (
                    <div className="mt-2 flex justify-center">
                      <Spinner />
                    </div>
                  )}
                </div>
              )}

              <div className="w-[100%]">
                <label htmlFor="latest-paragraph" className={labelClass}>
                  Carousal Paragraph
                </label>
                <input
                  id="latest-paragraph"
                  value={Paragraph}
                  onChange={(e) => setParagraph(e.target.value)}
                  type="text"
                  placeholder="Please Enter Paragraph"
                  className={inputClass}
                />
              </div>

              <div className="w-[100%]">
                <label htmlFor="latest-image" className={labelClass}>
                  Carousal Image
                </label>
                <input
                  id="latest-image"
                  onChange={uploadImageChange}
                  type="file"
                  accept="image/*"
                  className={`${inputClass} file:mr-4 file:py-1 file:px-3 file:rounded-lg file:border-0 file:text-[12px] file:bg-[#E52324]/20 file:text-[#E52324]`}
                />
                {image && (
                  <p className="mt-2 text-[11px] text-white/35">
                    Selected: {image.name}
                  </p>
                )}
              </div>

              <button
                className="w-full py-3 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[14px] transition-colors"
                style={{ fontWeight: 700 }}
                onClick={createeventFunction}
              >
                Create
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FeatureEvents;
